import React from 'react';
import { Col, EditableInfoComponent, Row } from 'components';
import { ManagementIcon } from 'components/common/icons';
import { Manager } from 'components/common/management/Manager';
import { ManagerModel } from 'models/Manager';

interface IManagement {
  title?: string;
  hasAccessToEdit: boolean;
  onAddModalStateChange: () => void;
  managementData: { role: string; data: ManagerModel | undefined }[];
}

export const Management = React.memo<IManagement>((props) => {
  const { title = 'Management', onAddModalStateChange, managementData, hasAccessToEdit } = props;

  return (
    <>
      <EditableInfoComponent
        title={title}
        editable={hasAccessToEdit}
        icon={<ManagementIcon />}
        onEdite={onAddModalStateChange}
      />
      <Row gutter={[0, 12]} style={{ marginBottom: 24 }}>
        {managementData.map(({ role, data }) => (
          <Col span={24} key={role}>
            <Manager role={role} data={data} />
          </Col>
        ))}
      </Row>
    </>
  );
});
